// ABOUTME: Local accessible checkbox adapter for compact table cells.
// ABOUTME: Used where @hm/fundamental has no exported standalone Checkbox component.
import React from 'react'

export interface InlineCheckboxProps {
  checked: boolean
  label: string
  disabled?: boolean
  onChange: (checked: boolean) => void
  'data-cy'?: string
}

export const InlineCheckbox: React.FC<InlineCheckboxProps> = ({
  checked,
  label,
  disabled = false,
  onChange,
  'data-cy': dataCy,
}) => (
  <input
    type="checkbox"
    checked={checked}
    disabled={disabled}
    aria-label={label}
    onChange={(e) => onChange(e.target.checked)}
    data-cy={dataCy}
    className="size-4 shrink-0 rounded-sm border border-foreground_faded accent-primary cursor-pointer disabled:cursor-not-allowed"
  />
)
